import { createServerFn } from '@tanstack/react-start'

import { getStorefrontConfig, listStorefrontCategories, listStorefrontProducts } from './dropify'
import type { StorefrontProductListParams } from './dropify'

// Product pagination is invoked after hydration. Keep the dashboard request on
// the app server so the browser only calls a same-origin TanStack server route.
export const listStorefrontProductsServer = createServerFn({ method: 'GET' })
  .inputValidator((params: StorefrontProductListParams) => params)
  .handler(({ data }) => listStorefrontProducts(data))

export const getStorefrontConfigServer = createServerFn({ method: 'GET' })
  .handler(() => getStorefrontConfig())

export const listStorefrontCategoriesServer = createServerFn({ method: 'GET' })
  .handler(() => listStorefrontCategories())
